import { Component, Input } from '@angular/core';

@Component({
    selector: 'ca-icon',
    templateUrl: 'icon.component.html',
    styleUrls: ['icon.component.scss'],
    standalone: false
})
export class IconComponent {
  @Input() name: string;
  @Input() badgeClass = '';
  @Input() label: string;
}
